import React from 'react'
import Sidbar from './Sidbar'
import Header from './Header'
import { useState } from 'react'
import Login from '../pages/auth/Login'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
const MainLayout = ({ children }) => {
  const [open, setOpen] = useState(false)
  const userAuth = window.localStorage.getItem('accessToken')
  const navigate = useNavigate()
  useEffect(() => {
    if (!userAuth) {
      // navigate('/login')
    }
  })
  return (
    <>
      {userAuth ? (
        <div>
          <div className="fixed inset-y-0 z-50 flex flex-col">
            <Sidbar open={open} setOpen={setOpen} />
          </div>
          <div>
            <Header open={open} setOpen={setOpen} />
            <main className="h-[calc(100vh-62px)] md:w-[calc(100%-256px)] ml-auto">{children}</main>
          </div>
        </div>
      ) : (
        <main className="h-[calc(100vh-62px)] md:w-[calc(100%-256px)] ml-auto">
          <Login></Login>
        </main>
      )}
    </>
  )
}

export default MainLayout
